// extracted by mini-css-extract-plugin
export var audioPlayer = "_ui-0";